export enum FirebaseMessageType {
    ADDED = "added",
    REMOVED ="removed",
    MODIFIED = "modified"
}

export interface TimeSpanFromFirebase {
    seconds: number;
    nanoseconds: number;
}